// vanilla js on document ready

const featuredCollections = () => {
  const featuredCollections = document.querySelectorAll('.featured-collections');


  featuredCollections.forEach((collection) => {
    const filterButtons = collection.querySelectorAll('.featured-collections__filter li');
    const collectionItems = collection.querySelectorAll('slider-component');

    filterButtons.forEach((button) => {

      button.addEventListener('click', () => {
        const filterID = button.getAttribute('id');


        filterButtons.forEach((button) => {
          button.classList.remove('active');
        })

        button.classList.add('active');

        collectionItems.forEach((item) => {
          // item.classList.a('hidden');
          if (item.getAttribute('id') === filterID) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        })
        alignProductCard();


      })
    })
  })
}

const productCardVideos = () => {
  const videoBtns = document.querySelectorAll('.js-video-modal');
  const modal = document.querySelector('.product-card-video-modal');
  const video = modal.querySelector('video');
  const modalInfo = document.querySelector('.product-card-video-modal__info');
  const image = modalInfo.querySelector('img');
  const ahref = modalInfo.querySelector('a')
  const title = modalInfo.querySelector('.title');
  const price = modalInfo.querySelector('.price');
  const quickbuyBtn = modalInfo.querySelector('.button');

  let activeQuickbuyListener = null; // Placeholder for the current quickbuy event listener

  const closeBtn = document.querySelector('.product-card-video-modal__cose')

  closeBtn.addEventListener('click', () => {
    closeModal()
  });

  const closeModal = () => {
    modal.classList.remove('active', 'show');
    document.body.classList.remove('overflow-hidden');
    video.pause();
    video.src = ''; // Clear the video source
    image.src = ''; // Clear the image source
    if (activeQuickbuyListener) {
      quickbuyBtn.removeEventListener('click', activeQuickbuyListener); // Remove the existing event listener
      activeQuickbuyListener = null; // Reset the reference
    }
  };

  const openModal = (btn, noContent) => {
    const videoID = btn.getAttribute('data-src');
    const wrap = btn.closest('.card-wrapper');
    const productQuickbuy = wrap?.querySelector('.quick-add__submit');

    video.src = videoID;
    video.play();


    modal.classList.add('active');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => modal.classList.add('show'), 100);

    if (noContent) {
      modalInfo.style.display = 'none';
    } else {
      const productTitle = wrap.querySelector('.card__heading a').textContent || '';
      const productPrice = wrap.querySelector('.card-product__price-wrap');
      const imageSrc = btn.getAttribute('data-product-image');
      const link = btn.getAttribute('data-link')



      //create anchor 


      ahref.setAttribute('href', link)
      modalInfo.style.display = 'grid';
      image.src = imageSrc;
      title.textContent = productTitle;
      price.innerHTML = productPrice ? productPrice.innerHTML : '';

      const quickbuyAction = (e) => {
        e.preventDefault();
        productQuickbuy?.click();
        closeModal();
      };

      if (activeQuickbuyListener) {
        quickbuyBtn.removeEventListener('click', activeQuickbuyListener);
      }
      quickbuyBtn.addEventListener('click', quickbuyAction);
      activeQuickbuyListener = quickbuyAction; // Update the reference to the current listener
    }
  };

  videoBtns.forEach((btn) => {
    btn.addEventListener('click', () => openModal(btn, btn.classList.contains('js-video-modal-no-content')));
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Add event listener to close modal when pressing "Esc" key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  });
};

const swiperJS = () => {
  const swipers = document.querySelectorAll('.swiper');


  swipers.forEach((swiperWrap) => {
    const sliderType = swiperWrap.getAttribute('data-section');
    let swiper

    switch (sliderType) {
      case 'swatch':
        const numberOfSlides = Math.floor(swiperWrap.querySelectorAll('.swiper-slide').length);
        swiper = new Swiper(swiperWrap, {
          slidesPerView: 4,
          spaceBetween: 20,
          loop: true,
          initialSlide: numberOfSlides / 2,
          centeredSlides: true,
          mousewheel: {
            forceToAxis: true
          },


          breakpoints: {
            768: {
              slidesPerView: 5,
            },
            1024: {
              slidesPerView: 6.5,
              spaceBetween: 50,
            },
          }
        });
        break;
      case 'oos':
        swiper = new Swiper(swiperWrap, {
          slidesPerView: 1.62,
          spaceBetween: 16,

          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
          pagination: {
            el: '.swiper-pagination',
          }
        });
        break;
      case 'testomonials':
        swiper = new Swiper(swiperWrap, {
          slidesPerView: 1,
          spaceBetween: 20,

          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
          },
          pagination: {
            el: '.swiper-pagination',
          }
        });
        break;
      default:
        swiper = new Swiper(swiperWrap, {
          slidesPerView: 2,
          spaceBetween: 53,

          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 64,
            },
          },
          pagination: {
            el: '.swiper-pagination',
          }
        });
    }
  })
}

const productImageFilter = () => {
  const filterWrap = document.querySelectorAll('.image-with-text-filter-container');

  filterWrap.forEach((wrap) => {


    const filterButtons = wrap.querySelectorAll('.image-with-text-filter__filter li');
    const innerSections = wrap.querySelectorAll('.image-with-text-filter');

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filterID = button.getAttribute('id');



        filterButtons.forEach((button) => {

          // button.classList.remove('active');
          if (button.classList.contains('mobile-btn')) {
            button.classList.remove('active');
          }
        })

        if (button.classList.contains('mobile-btn')) {
          button.classList.add('active');
        }



        // button.classList.add('active');


        innerSections.forEach((section) => {
          if (section.getAttribute('id') === filterID) {
            section.classList.add('active');

          } else {
            section.classList.remove('active');
          }
        })
      })
    })
  })

}

const realReviews = () => {
  const reviewsFilter = document.querySelector('.reviews-filter');
  if (!reviewsFilter) {
    return;
  }
  const reviewFilterBtns = reviewsFilter.querySelectorAll('a');
  const reviewItems = document.querySelectorAll('.real-reviews__card');
  const cardsWrap = document.querySelector('.real-reviews__wrap');



  reviewItems.forEach((item) => {
    const readMoreBtn = item.querySelector('.reviews-read-more');

    if (!readMoreBtn) {
      return
    }

    readMoreBtn.addEventListener('click', (e) => {
      e.preventDefault();

      item.classList.toggle('expanded');

      //copy item content and append to modal

      //scroll to top of modal
      // document.querySelector('.review-modal__content').scrollIntoView({ behavior: 'smooth' });

      const modal = document.querySelector('.review-modal');
      const modalContent = modal.querySelector('.review-modal__content');
      // const modalClose = modal.querySelector('.review-modal__close');

      modalContent.innerHTML = item.innerHTML;
      modal.classList.add('active');
      document.body.classList.add('overflow-hidden');
      modalContent.scrollTop = 0;

      modal.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.classList.remove('active');
          document.body.classList.remove('overflow-hidden');


          //scroll to top of modal only within modal content

        }
      })

    })
  })



  reviewFilterBtns.forEach((btn) => {

    btn.addEventListener('click', (e) => {


      cardsWrap.classList.add('transition');


      setTimeout(() => {
        cardsWrap.classList.remove('transition');
      }, 400);



      e.preventDefault();
      const filterID = btn.getAttribute('data-filter');

      reviewFilterBtns.forEach((button) => {
        button.classList.remove('active');
      })

      btn.classList.add('active');

      setTimeout(() => {
        if (filterID === 'all') {
          reviewItems.forEach((item) => {
            item.classList.add('active');
          })
          return;
        }

        reviewItems.forEach((item) => {



          if (item.getAttribute('data-category') === filterID) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        })
      }, 400);
    })
  })
}

function alignProductCard() {
  let currentRow = [];
  let previousTop = -1;
  let maxHeadingHeight = 0;


  const flexItems = document.querySelectorAll('.product-grid li');

  flexItems.forEach(item => {
    const rect = item.getBoundingClientRect();
    const top = rect.top;

    if (top !== previousTop) {
      if (currentRow.length > 0) {
        // Process the current row
        processRow(currentRow, maxHeadingHeight);
        maxHeadingHeight = 0; // Reset max heading height for the next row
      }
      // Start a new row
      currentRow = [item];
      previousTop = top;
    } else {
      currentRow.push(item);
    }

    // Get the heading element in the current item
    const headingElement = item.querySelector('.card__information-wrap .card__heading');
    console.log(headingElement);
    if (headingElement) {
      // Get the height of the heading element
      const computedStyle = getComputedStyle(headingElement);
      const headingHeight = parseFloat(computedStyle.height);

      console.log(headingElement.offsetHeight);


      // console.log(headingHeight);
      // console.log(headingElement.innerHTML);
      // console.log(headingElement.offsetHeight);
      // Update maxHeadingHeight if necessary
      if (headingHeight > maxHeadingHeight) {
        maxHeadingHeight = headingHeight;
      }
    }
  });

  // Process the last row
  processRow(currentRow, maxHeadingHeight);


}

function processRow(rowItems, maxHeight) {
  rowItems.forEach(item => {

    const headingElement = item.querySelector('.card__information-wrap .card__heading');
    if (headingElement) {

      headingElement.style.minHeight = `${maxHeight}px`;
    }
  });
}

const savingsBadge = () => {

  const savingsWrap = document.querySelector('product-info .badge-pdp-sale')


  if (!savingsWrap) {
    console.log('no savings badge');
    return;
  } else {
    console.log('savings badge');
  }

  const savings = document.querySelector('product-info .badge-pdp-sale').innerHTML;


  document.addEventListener('click', function (event) {
    console.log('clicked');


    if (event.target.closest('.shopify-app-block .seal-row')) {
      const priceLabel = document.querySelector('.product__info-wrapper .price-item.price-item--last');

      const sealRow = event.target.closest('.shopify-app-block .seal-row');
      priceLabel.innerHTML = sealRow.querySelector('.shopify-app-block .sls-price .money.conversion-bear-money').innerHTML;




      const upsellSubs = document.querySelectorAll('.complementary-slide .upsell-sub');



      if (sealRow.querySelector('.sls-selling-plan-group-name').innerHTML === 'One-time purchase') {

        document.querySelector('product-info .badge-pdp-sale').innerHTML = savings;


        upsellSubs.forEach((sub) => {
          const options = sub.querySelectorAll('.sls-option-container');

          if (options.length) {

            setTimeout(() => {
              options[0].querySelector('.sls-selling-plan-group-first-line').click()

            }
              , 100)

          }

        })
      }

      if (sealRow.querySelector('.sls-savings-badge')) {

        const savinbgBadgeText = sealRow.querySelector('.sls-savings-badge .conversion-bear-money').innerHTML;

        console.log(savinbgBadgeText);
        document.querySelector('product-info .badge-pdp-sale').innerHTML = "SAVE " + savinbgBadgeText;


        upsellSubs.forEach((sub) => {
          const options = sub.querySelectorAll('.sls-option-container');

          if (options.length) {



            setTimeout(() => {
              options[1].querySelector('.sls-selling-plan-group-first-line').click()

            }
              , 100)

          }

        })


      }
    }

  });


}

const pdpSlider = () => {

  const pdpSlider = document.querySelector('.product__media-list');

  if (!pdpSlider) {
    return;
  }
  const slideWidth = pdpSlider.offsetWidth; // Assuming all slides have the same width
  let startX;
  const slides = document.querySelectorAll('.product__media-list .product__media-item');



  const isiPhone = () => {
    return /iPhone/i.test(navigator.userAgent);
  };

  if (isiPhone()) {
    pdpSlider.addEventListener('touchstart', function (event) {
      startX = event.touches[0].clientX;
    });

    slides.forEach((slide) => {
      slide.style.scrollSnapAlign = 'none';
    })

    pdpSlider.addEventListener('touchend', function (event) {
      const endX = event.changedTouches[0].clientX;
      const deltaX = endX - startX;

      // Set a threshold for swipe detection
      const swipeThreshold = Math.abs(deltaX) > 50;

      if (swipeThreshold) {
        const currentScroll = pdpSlider.scrollLeft;
        const currentIndex = Math.round(currentScroll / slideWidth);
        const maxIndex = pdpSlider.scrollWidth / slideWidth - 1;

        // Swipe left
        if (deltaX < 0 && currentIndex < maxIndex) {
          const nextIndex = currentIndex + 1;
          pdpSlider.scrollTo({
            left: nextIndex * slideWidth,
            behavior: 'smooth'
          });
        }
        // Swipe right
        else if (deltaX > 0 && currentIndex > 0) {
          const prevIndex = currentIndex - 1;
          pdpSlider.scrollTo({
            left: prevIndex * slideWidth,
            behavior: 'smooth'
          });
        }
      }
    });
  }


}



document.addEventListener('DOMContentLoaded', function () {
  featuredCollections();
  productCardVideos();
  swiperJS()
  productImageFilter();
  realReviews();
  // alignProductCard();
  savingsBadge()
  pdpSlider()





















});

//when window is resized
window.addEventListener('resize', function () {
  // alignProductCard();
});